import AppointApi from "../../../../api/smp/org/AppointApi.js";

export default {
    paged:true,
    headers: [
        {text: '编号',value: 'userId',sortable: false,width: 150,divider: true},
        {text: '姓名',align: 'start',sortable: false,value: 'userName',width: 120,divider: true},
        {text: '性别',align: 'center',sortable: false,value: 'sexName',width: 40,divider: true},
        {text: '人员状态',align: 'center',sortable: false,value: 'statusName',width: 60,divider: true},
        {text: '手机',align: 'start',sortable: false,value: 'mobile',width: 200,divider: true},
        {text: '部门编号',align: 'start',sortable: false,value: 'deptId',width: 120,divider: true},
        {text: '部门名称',align: 'start',sortable: false,value: 'deptName',width: 120,divider: true},
        {text: '组织',align: 'start',sortable: false,value: 'orgName',width: 120,divider: true},

        {text: '任职状态',align: 'start',sortable: false,value: 'positionStatusName',width: 120,divider: true},
        {text: '任职开始时间',align: 'start',sortable: false,value: 'positionBeginDate',width: 120,divider: true},
        {text: '任职结束时间',align: 'start',sortable: false,value: 'positionEndDate',width: 120,divider: true},


    ],

    transformQueryResultRec2EditorRec(queryResultRec){
        let editorRec = {};
        //注意，可能需要深度拷贝
        Object.assign(editorRec,queryResultRec);
        editorRec.id=queryResultRec.userId;
        return editorRec;
    },

    async loadData(params,callback){
        let me = this;
        
        let aParam = {};
        Object.assign(aParam,params);
        aParam.orgId = params.selectedOrgId;

        let queryAppointResp = await AppointApi.queryAppoint(aParam);
        console.log("load user returned;");

        console.log(queryAppointResp);
        
        let data = queryAppointResp.data;
        if((!data)||(!(data.code))||(data.code!=200)){
            let msg=data.msg;
            msg = ((!msg)||(msg==''))?'获取人员情况失败':msg;
            throw new Error(msg);
            return;
        }
        if((!data.data)||(!data.data.appoints)){
            throw new Error('获取人员情况失败(无数据)');
            return;
        }
        
        let appoints = data.data.appoints;
        let total = data.data.total;
        this.dealData(appoints);
        callback({records:appoints,total:total});
    },

    dealData(records){
        records.forEach(function(rec){
            if(rec && rec.sex){
                if(rec.sex==0)
                    rec.sexName='男';
                else if(rec.sex==1)
                    rec.sexName='女';
                else
                    rec.sexName="未知";
            }else
                rec.sexName="未知";

            if(rec && rec.status){
                if(rec.status==0)
                    rec.statusName='停用';
                else if(rec.status==1)
                    rec.statusName='启用';
                else
                    rec.statusName="未知";
            }else
                rec.statusName="未知";    
            
            if(rec && rec.positionStatus){
                if(rec.positionStatus==0)
                    rec.positionStatusName='停用';
                else if(rec.positionStatus==1)
                    rec.positionStatusName='启用';
                else
                    rec.positionStatusName="未知";
            }else
                rec.positionStatusName="未知";      
            
        });
    }
}


